 // msdk javascriptå°è£…ä»£ç 
 var uniqueId = 1
 var msdkiOSHandler

 function log(message, data) {
   var log = document.getElementById('log')
   var el = document.createElement('div')
   el.className = 'logLine'
   el.innerHTML = uniqueId++ + '. ' + message + ':<br/>' + JSON.stringify(data)
   if (log && log.children && log.children.length) {
     log.insertBefore(el, log.children[0]);
   } else if (log) {
     log.appendChild(el);
   } else {
     //
   }
 }

 window.onerror = function(err) {
   log('window.onerror: ' + err)
 }

 function setupWebViewJavascriptBridge(callback) {
     if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
     if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
     window.WVJBCallbacks = [callback];
     var WVJBIframe = document.createElement('iframe');
     WVJBIframe.style.display = 'none';
     WVJBIframe.src = 'https://__bridge_loaded__';
     document.documentElement.appendChild(WVJBIframe);
     setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
 }
 // ---MSDK æµ‹è¯•æ–¹æ³•ï¼Œæ¸¸æˆæµ‹éœ€è¦æ ¹æ®è‡ªå·±çš„æ¡ä»¶è¿›è¡Œåˆ¤æ–­---
 function isiOS() {
   return (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream
 }

 setupWebViewJavascriptBridge(function(bridge) {
     msdkiOSHandler = bridge.callHandler
     bridge.registerHandler('MSDKJSHandler', function(data, responseCallback) {
         log('ObjC called MSDKJSHandler with', data)
         alert(data)
     })
 })


 function selfWebLogin(data){
     console.log('selfWebLogin invoked -- start');
     var loginDataVar = document.getElementById('loginData').value;
     if (loginDataVar == '') {
         loginDataVar = data;
     }
     if (isiOS()) {
       window.webkit.messageHandlers.MSDKSelfWeb.postMessage(loginDataVar);
     } else {
       MSDKSelfWeb.onResult(loginDataVar);
     }
 }

function setVideoLocalPath(){
   console.log('selfWebLogin invoked -- start');
   var localPath = document.getElementById('iOSVideoLocalPath').value;
   if (localPath == '') {
       console.log('local path is empty');
   }else{
       iOSLocalVideoPath = localPath;
   }
}

function msdkCloseWebview() {
 msdkCall('{"MsdkMethod":"closeWebView"}')
}

 // å®šä¹‰å¸¸é‡ -START-
 var JSON_BEGIN = '{';
 var JSON_END = '}';
 var JSON_DOT = ',';
 var METHOD_SHARE = '"MsdkMethod":"shareWebView"';
 var METHOD_SEND = '"MsdkMethod":"sendMsgWebView"';
 var CHANNEL_QQ = '"channel":"QQ"';
 var CHANNEL_WECHAT = '"channel":"WeChat"';
 var DATA_SEND_LINK_Q = '"actionReport":"MSG_INVITE","desc":"æ–‡æœ¬å‘é€æµ‹è¯•","imagePath":"http:\/\/mat1.gtimg.com\/www\/qq2018\/imgs\/qq_logo_2018x2.png","link":"https:\/\/www.facebook.com","messageExt":"messageExt","tailLogo":"WECHAT_SNS_JUMP_APP","thumbPath":"http:\/\/mat1.gtimg.com\/www\/qq2018\/imgs\/qq_logo_2018x2.png","title":"å¸¦ç¼©ç•¥å›¾åˆ†äº«","type":10001,"user":""';
 var QQ_SendMessage_LINK = JSON_BEGIN + CHANNEL_QQ + JSON_DOT + METHOD_SEND + JSON_DOT + DATA_SEND_LINK_Q + JSON_END;
 
 // MSDK js æµ‹è¯•æŽ¥å£
function msdkCall(data) {
   console.log('msdkCall invoked -- start');
   if (isiOS()) {
     msdkiOSHandler('MSDKCall', data, null)
   } else {
       if( data.indexOf("nativeCallJS")>-1 ) {
         console.log('msdkCall invoked nativeCallJS : ' + data);
         alert(data)
       } else {
         console.log('msdkCall invoked : ' + data);
         prompt(data)
       }
   }
 }

// 鸿蒙分享到qq专用
function harmonyShareToQQ(link) {
  const linkObj = JSON.parse(link);  // 先解析为对象
  var data = JSON.stringify({
    MsdkMethod: 'jsCallNative',
    type: 'execCallJS',
    IsEmbedWebView: true,
    title: linkObj.title,
    desc: linkObj.desc,
    url: linkObj.link,
    ImagePath: 'https://dlied5.qq.com/hlgame/hlwq/terminal/client/com_tencent_msdk_push_icon.png'
  })
  try {
    console.log('harmonyShareToQQ : ' + data);
    window.prompt(data)
  } catch (e) {
    // 客户端未注册 onPrompt 时兜住异常，避免中断点击处理
    console.warn('share failed:', e)
  }
}

// iOS Video è·¯å¾„ä¸ä¸€æ ·
function msdkCallShareQQVideo() {
   console.log('msdkCall invoked -- start');
   if (isiOS()) {
       var QQ_Share_Local_video = '';
       if (iOSLocalVideoPath != ''){
           var shareData  = '"actionReport":"MSG_INVITE","desc":"çŽ‹è€…æ—¶åˆ»","imagePath":"http:\/\/mat1.gtimg.com\/www\/qq2018\/imgs\/qq_logo_2018x2.png","link":"http:\/\/www.qq.com\/","mediaPath":"' +iOSLocalVideoPath + '","messageExt":"messageExt","tailLogo":"WECHAT_SNS_JUMP_APP","thumbPath":"http:\/\/mat1.gtimg.com\/www\/qq2018\/imgs\/qq_logo_2018x2.png","title":"æ¸¸æˆè§†é¢‘","type":10005,"user":""';
           
           //iOSLocalVideoPath
           QQ_Share_Local_video = JSON_BEGIN + CHANNEL_QQ + JSON_DOT + METHOD_SHARE + JSON_DOT + shareData + JSON_END
       }else{
           console.log('local video path is empty');
           QQ_Share_Local_video = QQ_Share_VIDEO;
       }
       
       msdkiOSHandler('MSDKCall', QQ_Share_Local_video, null)
   } else {
     msdkCall(QQ_Share_VIDEO)
   }
}


 // åˆ¤æ–­appæ˜¯å¦å®‰è£…
 function msdkIsAppInstalled(target, callback){
   if(isiOS()){
     var params = '{"MsdkMethod":"isAppInstalled","packageUrl":"' + target + '"}';
     msdkiOSHandler('MSDKCall', params, callback);
   }else{
     var params = '{"MsdkMethod":"isAppInstalled","package":"' + target + '"}';
     callback(prompt(params));
   }
 }
 
function iOSVisibleOnly() {
 var iOSOnlyDiv = document.getElementById("iOS_Only");
   if (isiOS()) {
     iOSOnlyDiv.setAttribute("style","display");
   } else {
     iOSOnlyDiv.setAttribute("style","display:none");
   }
}


function getUserAgent() {
   var agent = navigator.userAgent;
   alert(agent);
}
function demoIsQQInstalled(){
 if(isiOS()){
   msdkIsAppInstalled("mqq://", function(resp){
     alert(resp);
   });
 }else{
   msdkIsAppInstalled("com.tencent.mobileqq", function(resp){
     alert(resp);
   });
 }  
}
   
function demoIsTimInstalled(){
   if(isiOS()){
     msdkIsAppInstalled("tim://", function(resp){
       alert(resp);
     });
   }else{
     msdkIsAppInstalled("com.tencent.tim", function(resp){
       alert(resp);
     });
   }
}
   
function demoIsWeChatInstalled(){
 if(isiOS()){
   msdkIsAppInstalled("weixin://", function(resp){
     alert(resp);
   });
 }else{
   msdkIsAppInstalled("com.tencent.mm", function(resp){
     alert(resp);
   });
 }  
}

function mUploadFile(fileObj) {
 var file = fileObj.files[0];
 var fileReader = new FileReader();
 fileReader.onloadend = function () {
   if (fileReader.readyState == fileReader.DONE) {
       document.getElementById('img').setAttribute('src', fileReader.result);
   }
 };
 fileReader.readAsDataURL(file);
}

//检测是否为安卓手机
function isAndroid() {
  var REGXP_ANDROID = /.*(Android).*/;
  if(REGXP_ANDROID.test(navigator.userAgent)){ // 安卓手机
    return true;
  }
  return false;
}

//检测是否为ios手机
function isIos(){
  var REGEXP_IOS = /.*?(iPad|iPhone|iPod).*/;
  if(REGEXP_IOS.test(navigator.userAgent)){ // ios手机
    return true;
  }
  return false;
}

// 纯血鸿蒙（HarmonyOS NEXT），UA 中不再带 Android 标识
function isHarmony() {
  var REGEXP_HARMONY = /OpenHarmony/i;
  return REGEXP_HARMONY.test(navigator.userAgent);
}

//检测是否为纯血鸿蒙 NEXT(不基于Android)
function isHarmonyNext(){
  var REGEXP_HARMONY_NEXT = /.*?(OpenHarmony|OHOS|ArkWeb).*/i;
  if(REGEXP_HARMONY_NEXT.test(navigator.userAgent)){
    return true;
  }
  return false;
}

//检测是否为移动浏览器
function isMobile() {
  if(isAndroid()||isIos()||isHarmony()){
    return true;
  }
  return false
}

export {msdkCloseWebview, isMobile, isAndroid, isHarmony, isHarmonyNext, msdkCall, harmonyShareToQQ};
 // ---JsæŽ¥å£ END---